import { call } from 'redux-saga/effects'

import { goToStep } from './common'

export default function* appComplete() {
  yield call(goToStep, 'final')
}
